import { ReactNode } from "react";
import { ShipmentType } from "entities/shared/shipmentCard.types";
import { searchFilterStore } from "entities/SearchFilter";
import { useAppSelector } from "shared/lib/redux";
import { ValueOf } from "shared/lib/typeCheck.lib";
import { AirOpenedCardView } from "./OpenedCardViews/AirOpenedCard";
import { ParcelOpenedCardView } from "./OpenedCardViews/ParcelOpenedCard";
import { RailOpenedCardView } from "./OpenedCardViews/RailOpenedCard";
import { RoadOpenedCardView } from "./OpenedCardViews/RoadOpenedCard";
import { SeaOpenedCardView } from "./OpenedCardViews/SeaOpenedCard";

const mainViewsMap: Record<ValueOf<typeof ShipmentType>, ReactNode> = {
  [ShipmentType.AIR]: <AirOpenedCardView />,
  [ShipmentType.SEA]: <SeaOpenedCardView />,
  [ShipmentType.RAIL]: <RailOpenedCardView />,
  [ShipmentType.ROAD]: <RoadOpenedCardView />,
  [ShipmentType.PARCEL]: <ParcelOpenedCardView />,
};

export const OpenedCardView: RFC = () => {
  const shipmentType = useAppSelector(searchFilterStore.selectors.shipment);

  return mainViewsMap[shipmentType];
};
